import {defineStore} from 'pinia'
import {LoginResponse} from "lib/co-login";

// export const useSessionStore
//   = defineStore('session', () => {
//  
//   const status = ref<LoginStatus>('notLogin')
//   const info = ref<UserInfo | null>(null)
//  
//   const loginStatus = ref<LoginResponse | null>(null)
//  
//   return {
//     status, info, loginStatus
//   }
// })


export const useSessionStore = defineStore('session', {

  // https://pinia.vuejs.kr/core-concepts/state.html#TypeScript
  state: () => ({
    loginStatus: null as LoginResponse | null,
    loginLastGet: 0 as number,
  }),
  getters: {
    isLogin: (state) => state.loginStatus?.login,
    // doubleCount: (state) => state.count * 2,
    dp: (state) => {
      const user = state?.loginStatus?.user
      return user
        ? `${user.name} ( ${user.id} )`
        : '로그인 안됨'
    },
    /** 파트장 여부 */
    isPartManager: (state) => {
      const team = state.loginStatus?.user?.team ?? "";
      if (!team) return false;
      return ["/ponline/", "/pvisit/", "/pafter/"].some(keyword =>
          team.includes(keyword)
      );
    },
    /** 프리랜서 권한만 있는지 여부 */
    isOnlyFreeRole: (state) => {
      const team = state.loginStatus?.user?.team ?? "";
      if (!team) return false;

      // "fr_visit" 또는 "fr_pcoach" 이외의 권한이 하나라도 있으면 false
      return team
          .split("/")
          .filter(role => role) // 빈 문자열 제외
          .every(role => role === "fr_visit" || role === "fr_pcoach"); // 프리랜서 권한 - aSPxQVnZnOGv8ulS
    }
      
  },
  actions: {
    // increment() {
    //   this.count++
    // },
  },
})
